import ImageHandler from './image-handler'

export default ImageHandler
